import React from 'react';

interface OnboardingGateProps {
  children: React.ReactNode;
}

export const OnboardingGate: React.FC<OnboardingGateProps> = ({ children }) => {
  // Auto-skip onboarding for Cloudflare deployment - API key handled via env vars
  return <>{children}</>;
};
